export default () => {
  const params = {
    howToSignSlider: $(".how-to-sign-slider"),
    statusHowToSign: $(".js-slide-counter-how"),
    sliderNavigationItem: $(".navigation-options__item"),
    sliderHiddenText: $(".sign-explanation-hidden-text"),
    sliderHiddenTextTrigger: $(".js-show-sign-explanation"),
    sliderVisibleTextTrigger: $(".js-hide-sign-explanation"),
    accordionTrigger: $(".how-to-sign-accordion-title"),
    accordionBody: ".page-section__row--how-to-sign",
    nextArrow: $(".js-how-to-sign-slider-arrow .btn-next-arrow"),
    prevArrow: $(".js-how-to-sign-slider-arrow .btn-prev-arrow"),
    signIllustration: $(".sign-illustration"),
    tabletBreakpoint: 959,
    showMoreDescriptionLink: $(".sign-explanation__link"),
    showMoreDescription: $(".sign-explanation__description"),
    moreText: "Read more",
    lessText: "Read less"
  }

  // Slider

  params.howToSignSlider.on("init", function (currentSlide) {
    $(".carousel").addClass("is-visible");
    if (currentSlide) {
      $(this).find(".slick-current .js-how-to-sign-accordion-tablet").removeAttr("hidden");
    }
  });
  params.howToSignSlider.on("afterChange", function (currentSlide) {
    if (currentSlide) {
      $(".slick-slide .js-how-to-sign-accordion-tablet").attr("hidden", "hidden");
      $(this).find(".slick-current .js-how-to-sign-accordion-tablet").removeAttr("hidden");
    }
  });

  params.howToSignSlider.on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
    if (!slick.$dots) {
      return;
    }

    const counter = (currentSlide ? currentSlide : 0) + 1,
      sumCouner = slick.$dots[0].children.length;

    if (sumCouner < 10) {
      params.statusHowToSign.html("<b>0" + counter + "</b> " + "&nbsp;/&nbsp;0" + sumCouner);
    } else if (counter < 10) {
      params.statusHowToSign.html("<b>0" + counter + "</b> " + "&nbsp;/&nbsp;" + sumCouner);
    } else {
      params.statusHowToSign.html("<b>" + counter + "</b> " + "&nbsp;/&nbsp;" + sumCouner);
    }

    if (counter === 1) {
      params.prevArrow.addClass("is-disable");
      params.prevArrow.attr("tabindex", "-1");
    } else if (counter === sumCouner) {
      params.nextArrow.addClass("is-disable");
      params.nextArrow.attr("tabindex", "-1");
      params.prevArrow.removeClass("is-disable");
      params.prevArrow.removeAttr("tabindex", "-1");
    } else {
      params.nextArrow.removeClass("is-disable");
      params.nextArrow.removeAttr("tabindex", "-1");
      params.prevArrow.removeClass("is-disable");
      params.prevArrow.removeAttr("tabindex", "-1");
    }

  });

  params.howToSignSlider.slick({
    dots: true,
    arrows: false,
    infinite: false,
    speed: 300,
    adaptiveHeight: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: "ondemand",
    fade: true,
    responsive: [{
      breakpoint: 959,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }]
  });

  params.howToSignSlider.on("afterChange", function () {
    params.signIllustration.css("display", "block");
    params.showMoreDescription.removeClass("is-open");
    params.showMoreDescriptionLink.removeClass("less");
    params.showMoreDescriptionLink.html(params.moreText);
    $(".slick-list").removeClass("is-open");
    if ($(window).width() > params.tabletBreakpoint) {
      $(".how-to-sign-nav").css({top:""});
    }
  });
  params.howToSignSlider.on("beforeChange", function () {
    params.signIllustration.css("display", "none");
  });

  // Slider Navigation

  params.sliderNavigationItem.on("click focusin", function (e) {
    e.preventDefault();

    const slideIndex = $(this).index();
    params.howToSignSlider.slick("slickGoTo", parseInt(slideIndex));

    params.sliderNavigationItem.not(this).removeClass("is-active");
    params.sliderNavigationItem.not(this).attr("aria-selected", "false");
    $(this).addClass("is-active");
    $(this).attr("aria-selected", "true");
    params.sliderHiddenText.hide();
    params.sliderVisibleTextTrigger.show();
    params.sliderHiddenTextTrigger.show();

  });

  // AccordionMobile

  params.accordionTrigger.click(function () {

    const isOpen = $(this).next(params.accordionBody).is(":visible");
    if (isOpen === true) {
      params.accordionTrigger.next(params.accordionBody).slideUp(170);
      params.accordionTrigger.removeClass("is-active");
    } else {
      params.accordionTrigger.not(this).next(params.accordionBody).slideUp(170);
      $(this).next(params.accordionBody).slideDown(170);
      params.accordionTrigger.not(this).removeClass("is-active");
      $(this).addClass("is-active");
    }

    params.sliderHiddenText.hide();
    params.sliderHiddenTextTrigger.show();
    params.sliderVisibleTextTrigger.show();
  });

  params.nextArrow.click(function (e) {
    params.howToSignSlider.slick("slickNext");
  });
  params.prevArrow.click(function (e) {
    params.howToSignSlider.slick("slickPrev");
  });

  params.showMoreDescriptionLink.click(function (e) {
    e.preventDefault();
    $(this).prev(params.showMoreDescription).toggleClass("is-open");


    if ($(this).hasClass("less")) {
      $(this).removeClass("less");
      $(this).html(params.moreText);
      $(".slick-list").removeClass("is-open");
    } else {
      $(this).addClass("less");
      $(this).html(params.lessText);
      $(".slick-list").addClass("is-open");
    }
    const targetNav = $(this).prev((".sign-explanation__description.is-open")).outerHeight(true) + $(this).outerHeight(true) + $(this).prevAll((".sign-explanation__title")).outerHeight(true) + 68;

    if ($(window).width() > params.tabletBreakpoint) {
      $(".how-to-sign-nav").css("top", targetNav);
    }
  });

  // ShowText
  $(".js-show-sign-explanation").click(function (e) {
    e.preventDefault();
    $(this).parent().next(".sign-explanation-hidden-text").slideDown(170);
    $(this).hide();
    $(this).parent().next(".sign-explanation-hidden-text").show();
  });

  $(".js-show-sign-explanation").click(function () {
    $(this).closest().next(".sign-explanation-hidden-text").slideUp();
  });

  // HideText

  params.sliderVisibleTextTrigger.click(function (e) {
    e.preventDefault();

    params.sliderHiddenText.slideUp(170);
    $(this).hide()
    params.sliderHiddenTextTrigger.show();
  });

  $(".how-to-sign-nav").css("width", $(".sign-illustration").width());

  if ($(window).width() < params.tabletBreakpoint) {
    $(".js-how-to-sign-accordion-tablet").removeAttr("hidden");
    $(".how-to-sign-nav").css("top", $(".page-section__column--media").outerHeight(true));
  }

  $(window).resize(function () {
    $(".how-to-sign-nav").css("width", $(".sign-illustration").width());

    if ($(window).width() < params.tabletBreakpoint) {
      $(".how-to-sign-nav").css("top", $(".page-section__column--media").outerHeight(true));
    }
  });
}
